import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/compiler/src/core';
import { MaterialModule } from '../../../../public_api';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { DatepickerComponent } from '../../components/datepicker/datepicker.component';
export class DatepickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  declarations: [
    DatepickerComponent
  ],
  exports: [
    DatepickerComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerModule_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
